export default {
  'commissionmanagement.commissionmanagement': 'ポイント管理',
  'commissionmanagement.accountsnotify': 'リンクから銀行口座を',
  'commissionmanagement.accountsnotify1': '管理してください',
  'commissionmanagement.accountmanagement': '銀行口座の管理',
  'commissionmanagement.description': '説明',
  'commissionmanagement.bankaccount': '口座番号',
  'commissionmanagement.save': '保存',
  'commissionmanagement.addrequest': 'ポイントの引き下ろし',
  'commissionmanagement.withdrawamount': '引き下ろし可能ポイント',
  'commissionmanagement.index': 'インデックス',
  'commissionmanagement.requestdate': 'リクエスト日',
  'commissionmanagement.requeststatus': 'リクエスト状態',
  'commissionmanagement.withdrawtype': '引き落としタイプ',
  'commissionmanagement.requestadd': '引き落としリクエストが追加されました',
  'commissionmanagement.tryagain': 'もう一度やり直してしてください',
  'commissionmanagement.deleterequest': '引き落としリクエストを削除',
  'commissionmanagement.deleteerror': 'このリクエストは削除できません',
  'commissionmanagement.disapprove': '不承認',
  'commissionmanagement.approve': '承認',
  'commissionmanagement.pending': '保留',
  'commissionmanagement.notpaid': '未払い',
  'commissionmanagement.paid': '支払い済み',
  'commissionmanagement.showdetail': '詳細を表示',
  'commissionmanagement.incomedetail': '収入の詳細',
  'commissionmanagement.withdrawreport': '取引レポート',
  'commissionmanagement.transferpoints': 'ポイントの転送',
  'commissionmanagement.buycard': 'テレフォンカードの購入',
  'commissionmanagement.paybill': '請求書の支払い',
  'commissionmanagement.spendpoints': 'ポイント利用',
  'commissionmanagement.lottery': 'ロータリー',
  'commissionmanagement.earnpoints': 'ポイントの獲得',
  'commissionmanagement.redandantrequest':
    '現在リクエストが保留中です、新しいリクエストを送信しないでください',
  'commissionmanagement.exitfee': '出国料金',
  'commissionmanagement.requestreport': '引き落としリクエストのレポート',
  'commissionmanagement.phrase': '文書番号',
  'commissionmanagement.documentdescription': '文書の説明',
  'commissionmanagement.transferamount': '譲渡可能なポイント',
  'commissionmanagement.pointamount': 'ポイント数',
  'commissionmanagement.secondpassword': '第2パスワード',
  'commissionmanagement.transfererror':
    'リクエストされたポイントは残りのポイント数を超えています',
  'commissionmanagement.transfernotify': 'ユーザーの皆様、ポイントの譲渡は',
  'commissionmanagement.transfernotify1': 'リンクから行ってください',
  'commissionmanagement.addsecondpassword': '第2パスワードを追加',
  'commissionmanagement.resecondpassword': '第２パスワードを再入力',
  'commissionmanagement.wagenotify1':
    'ユーザーの皆様、手数料がポイントから引き落とされます',
  'commissionmanagement.wagenotify2': '同意しますか？',
  'commissionmanagement.errorsecondpassword':
    '第2パスワードが登録されていません、まず第2パスワードを追加してください',
  'commissionmanagement.wrongsecondpassword': '第2パスワードが間違っています',
  'commissionmanagement.successtransfer': 'ポイントが譲渡されました',
  'commissionmanagement.notenoughpoint':
    'ポイントが保留中のため、リクエストされたポイントは許可されません',
  'commissionmanagement.sameprofiles': '送り主と受取先が同じです',
  'commissionmanagement.deleteconfirm':
    'ポイント引き落としリクエストを削除しますか？',
  'commissionmanagement.deletesucess': '引き出しリクエストが削除されました',
  'commissionmanagement.customer': '顧客',
  'commissionmanagement.employee': '従業員',
  'commissionmanagement.request': 'リクエスト',
  'commissionmanagement.income': '収入',
  'commissionmanagement.wallet': 'ウォレットのアップグレード',
  'commissionmanagement.customerregion': '地域別の顧客数',
  'commissionmanagement.totalpoint': '合計ポイント',
  'commissionmanagement.requestprice': 'リクエストされた金額',
  'commissionmanagement.sendsms': 'SMSの送信',
  'commissionmanagement.requestpoint': 'リクエストされたポイント',
  'commissionmanagement.wallettransaction': '最後のウォレットトランザクション',
  'commissionmanagement.recenttransactions': '最近の取引',
  'commissionmanagement.pointtransactions': 'ポイントトランザクション',
  'commissionmanagement.transitional': '過渡期',
  'commissionmanagement.exitfeepayment': '支払い終了手数料',
  'commissionmanagement.moneydescription':
    'ポイントをお金に変換して銀行口座に預けることができます.',
  'commissionmanagement.transferpointdescriptionTripsi':
    'このようにして、ポイントをTripsiユーザーに転送できます.',
  'commissionmanagement.transferpointdescriptionTripord':
    'このようにして、ポイントをTripordユーザーに転送できます.',
  'commissionmanagement.getpointdescription':
    'ポイントを増やして無料旅行をする方法はいくつかあります.',
  'commissionmanagement.spendpointdescription':
    'ポイントはさまざまなセクションで使用でき、無料のサービスを利用できます.',
  'commissionmanagement.buycarddescription':
    'ポイントを通じて、Hamrah Aval、Irancell、Taliyaのカードを無料で受け取ることができます.',
  'commissionmanagement.exitfeedescription':
    'あなたのポイントで、あなたは出口税を支払うことができます.',
  'commissionmanagement.transfermoney': '送金',
  'commissionmanagement.buypoint': '購入ポイント',
  'commissionmanagement.safeway': '最も安全な方法',
  'commissionmanagement.spendanywhere': 'どこでも使う',
  'commissionmanagement.deposit': 'アカウントへの入金',
  'commissionmanagement.easyway': '最も簡単な方法',
  'commissionmanagement.fastway': '最速の方法',
  'commissionmanagement.entersecondpassword':
    '番目のパスワードを入力してください',
  'commissionmanagement.usepoint': '親愛なる友よ、ポイントを上手に使いましょう',
  'commissionmanagement.buyCard': 'カードを購入',
  'commissionmanagement.InternalServer': '内部サーバーエラー',
};
